import Contact from "../../Components/Contact"
import "./contact.scss"

const ContactPage = () => {
  return (
    <Contact/>
  )
}

export default ContactPage